const config = {
  API_BASE_URL: process.env.NODE_ENV === 'development' 
    ? 'https://d30i0d0sv0fvad.cloudfront.net/api/v1' 
    : process.env.REACT_APP_API_BASE_URL || 'https://d30i0d0sv0fvad.cloudfront.net/api/v1',
  AWS: {
    REGION: process.env.REACT_APP_AWS_REGION || 'ap-south-1',
    S3_BUCKET: process.env.REACT_APP_S3_BUCKET || 'morningstardp'
  },
  auth: {
    // clientId: process.env.REACT_APP_AZURE_AD_CLIENT_ID,
    clientId: "05e22b35-2ed5-4483-8f3f-12f42b001e47",
    // authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_AD_TENANT_ID}`,
    authority: `https://login.microsoftonline.com/f8300747-02c3-470c-a3d6-5a3355e3d77d`,
    // redirectUri: process.env.REACT_APP_AZURE_AD_REDIRECTURI,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: "/", // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
}
};

export default config; 